module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Door-open-2ed3f76152cb8a556e74470cbd5b0923.svg";